import { z } from 'zod';
/** Approved public module prefixes; empty retains the legacy root deployment. */
export const publicBasePaths = [
    '',
    '/portal',
    '/cards',
    '/canteen',
    '/workflow',
    '/communication',
    '/notifications',
];
// Generated challenges are opaque base64url tokens. Match the entire local
// destination so absolute URLs, path normalization and extra query/fragment
// destinations cannot pass through a startsWith-only check.
export const reauthenticateUrlSchema = z.string().refine((value) => publicBasePaths.some((prefix) => {
    const route = `${prefix}/auth/reauth?challenge=`;
    return (value.startsWith(route) &&
        /^[A-Za-z0-9_-]+$/.test(value.slice(route.length)));
}), {
    message: 'Expected an approved local reauthentication route with an opaque challenge.',
});
/** Build a local module API/auth path; preserve the caller's query verbatim. */
export function publicRequestPath(base, path) {
    if (!publicBasePaths.some((prefix) => base === `${prefix}/`)) {
        throw new Error('invalid_public_request_base');
    }
    const pathname = path.split('?')[0];
    if (!/^\/(api|auth)\/.+/.test(pathname) ||
        path.includes('#') ||
        Array.from(path).some((character) => character.charCodeAt(0) <= 32 || character.charCodeAt(0) === 127)) {
        throw new Error('invalid_public_request_path');
    }
    for (const segment of pathname.slice(1).split('/')) {
        const decoded = decodeURIComponent(segment);
        if (!decoded ||
            decoded === '.' ||
            decoded === '..' ||
            /[\\/%?#]/.test(decoded) ||
            Array.from(decoded).some((character) => character.charCodeAt(0) <= 32 || character.charCodeAt(0) === 127)) {
            throw new Error('invalid_public_request_path');
        }
    }
    return `${base.slice(0, -1)}${path}`;
}
